import React from 'react';
import { Box } from '@mui/material';
import { pct, tarBand } from '../utils/trackerConfig';

// TAR as a coloured pill (green 100%+, amber 75-99%, red below) - shared by the grid, summary and cards
// `dense`: tighter padding and a smaller type, for a narrow column
export default function TarPill({ value, dense = false, decimals = 1 }) {
  const band = tarBand(value);
  if (!band) return <span style={{ color: '#94A3B8' }}>—</span>;
  return (
    <Box
      component="span"
      sx={{ display: 'inline-block', whiteSpace: 'nowrap', minWidth: dense ? 0 : 54, px: dense ? 0.4 : 1, py: 0.2, borderRadius: '12px', fontWeight: 700, color: band.fg, backgroundColor: band.bg }}
    >
      {pct(value, decimals)}
    </Box>
  );
}
